console.log('unique id v0.0.1');

export const unique = (() => {
  return {
    'id': (prefix = '') => {
      return `${prefix}${crypto.randomUUID()}`;
    }
  }
})();
